<template>
  <toast-notification ref="notification" />
  <loading-spinner
    ref="spinner"
    spinnerType="border"
    color="primary"
  ></loading-spinner>
  <div
    class="row justify-content-center my-3 scrollable-vertical scrollable-styled-dark"
    :style="!isMobile ? 'max-height: 70vh' : ''"
  >
    <div class="col-md-10">
      <div class="card mb-2 shadow border-0">
        <div class="card-header mb-0 p-0 border-0 bg-light"></div>
        <div class="card-body">
          <div class="row justify-content-center mt-4">
            <div class="col-md-10 my-1 p-3 rounded border shadow">
              <div id="passwordHelpBlock" class="form-text smaller mb-2">
                شماره عضویت مراجعی که قصد دارید انتقال اعتبار برای وی انجام دهید
                را وارد نمایید.
              </div>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  :class="{ isNotValid: !validatedSearchClientCode }"
                  placeholder="شماره عضویت"
                  aria-label="شماره عضویت"
                  aria-describedby="button-addon2"
                  v-model="searchClientCode"
                />
                <button
                  class="btn btn-blueSite"
                  type="button"
                  @click="findClientCode"
                >
                  <i class="fi fi-search pe-2"></i>
                </button>
              </div>

              <div>
                <span
                  v-if="!validatedSearchClientCode"
                  class="smaller text-danger"
                  >وارد کردن شماره عضویت الزامی است</span
                >
              </div>
            </div>
          </div>

          <div
            class="row justify-content-center mt-4"
            v-if="otherClientForTransferEntity.clientCode != ''"
          >
            <div class="col-md-10 my-1 p-3 rounded border shadow">
              <validation-summery
                v-if="formHasError"
                :errors="formError"
              ></validation-summery>
              <input-with-message
                containerClass="mt-2"
                errorMessage=""
                topTitle="شماره عضویت:"
                :required="true"
                :iconSpin="false"
                inputType="text"
                :disableInput="true"
                :showMessage="false"
                :hasLeftBox="false"
                :showIcon="false"
                :hasSideBox="true"
                topTitleClass="mb-1"
                v-model:inputValue="otherClientForTransferEntity.clientCode"
                input-size="sm"
              />
              <!-- <input-with-message
                containerClass="mt-2"
                errorMessage=""
                topTitle="نام مراجع:"
                :required="true"
                :iconSpin="false"
                inputType="text"
                :disableInput="true"
                :showMessage="false"
                :hasLeftBox="false"
                :showIcon="false"
                :hasSideBox="true"
                topTitleClass="mb-1"
                v-model:inputValue="otherClientForTransferEntity.clientFullName"
                input-size="sm"
              /> -->

              <input-with-message
                ref="priceInput"
                containerClass="mt-2"
                errorMessage="وارد کردن مقدار مبلغ الزامی است"
                erroMessageClass="text-danger smaller"
                topTitle="مبلغ:"
                :required="true"
                :iconSpin="false"
                inputType="intNumber"
                :showMessage="false"
                :hasLeftBox="true"
                :showIcon="false"
                :hasSideBox="true"
                :isDigitSeprator="true"
                :showDigiTranslate="true"
                :leftBoxTitle="getCurrentWallet()?.wallet_CurrencyType?.title"
                topTitleClass="mb-1"
                v-model:inputValue="entity.amount"
                input-size="sm"
              />
              <input-with-message
                copmponentType="textArea"
                containerClass="col-12 mt-2"
                topTitle="توضیحات:"
                inputThem="grayThem"
                :iconSpin="false"
                inputType="text"
                :showMessage="false"
                v-model:inputValue="entity.description"
                :hasSideBox="false"
              />
              <div class="text-center mt-2">
                <button
                  class="btn btn-sm rounded btn-blueSite"
                  @click="transferCreditButtonClick"
                >
                  <i class="fi fi-box-checked"></i>
                  تایید
                </button>
                <button
                  class="btn btn-sm rounded btn-blueSite"
                  @click="cancelButtonClick"
                >
                  <i class="fi mdi-close"></i>
                  انصراف
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import axios from 'axios';
import InputWithMessage from '../../../../components/form/inputWithMessage/InputWithMessage.vue';
import ValidationSummery from '../../../../components/form/errorBox/ValidationSummery.vue';

export default {
  components: { LoadingSpinner, InputWithMessage, ValidationSummery },
  inject: ['WalletList', 'SetSelectedTab', 'RefreshWalletList'],
  data() {
    return {
      formHasError: false,
      formError: [],
      isMobile: isMobile,
      validatedSearchClientCode: true,
      searchClientCode: '',
      entity: {
        fromWalletID: null,
        clientCode: null,
        amount: '',
        description: '',
      },
      otherClientForTransferEntity: {
        id: 0,
        currencyTypeID: 1,
        clientCode: '',
        personID: 0,
        clientFullName: '',
      },
    };
  },
  props: {
    selectedWalletID: {
      type: Number,
      required: true,
      default: 0,
    },
    clientID: {
      type: [String, Number],
      required: true,
    },
  },
  methods: {
    getCurrentWallet() {
      let wallet = this.WalletList().filter(
        (f) => f.id == this.selectedWalletID
      );
      if (wallet.length > 0) {
        return wallet[0];
      }
      return null;
    },
    resetEntity() {
      this.formHasError = false;
      this.formError = [];
      this.otherClientForTransferEntity = new Object({
        id: 0,
        currencyTypeID: 1,
        clientCode: '',
        personID: 0,
        clientFullName: '',
      });

      this.entity = new Object({
        toPersonID: null,
        amount: '',
        fromWalletID: null,
        description: '',
      });
    },
    async findClientCode() {
      if (!this.searchClientCode) {
        this.validatedSearchClientCode = false;
        return;
      }
      this.validatedSearchClientCode = true;
      this.$refs.spinner.show();
      let that = this;
      await axios
        .get(
          `/FN/Wallet/GetPersonWalletByClientCode?code=${this.searchClientCode}&&id=${that.$store.getters.userPersonID}`
        )
        .then((response) => {
          if (!response.data) {
            this.$refs.notification.show({
              type: 'error',
              title: `مراجع یا کیف پول معادل مورد نظر یافت نشد`,
            });

            that.otherClientForTransferEntity = new Object({
              id: 0,
              currencyTypeID: 1,
              clientCode: '',
              personID: 0,
              clientFullName: '',
            });

            return;
          }
          that.otherClientForTransferEntity = response.data;
          that.entity.clientCode = that.searchClientCode;
          that.entity.fromWalletID = that.selectedWalletID;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `دریافت اطلاعات مراجع با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },

    validate() {
      if (!this.entity.amount) {
        this.$refs.priceInput.showErrorMessage();
        this.$refs.priceInput.setFocus();
        return false;
      }

      if (this.entity.amount > this.getCurrentWallet()?.balance) {
        this.formHasError = true;
        this.formError.push('مبلغ وارد شده از میزان موجودی کیف پول بیشتر است');
        return false;
      }

      return true;
    },
    async transferCreditButtonClick() {
      this.formHasError = false;
      this.formError = [];
      if (!this.validate()) {
        return;
      }
      let that = this;
      that.$refs.spinner.show();
      await axios
        .post(`/FN/TransferCredit/CreateForSite`, that.entity)
        .then(async () => {
          that.$refs.notification.show({
            type: 'success',
            title: ` انتقال اعتبار با موفقیت ثبت گردید`,
          });
          // that.$store.dispatch('updateClientWalletBalance', that.clientID);
          await that.RefreshWalletList();
          that.cancelButtonClick();
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
          }
        })
        .finally(() => {
          that.$refs.spinner?.hide();
        });
    },
    cancelButtonClick() {
      this.SetSelectedTab('walletList');
      this.resetEntity();
    },
  },
  async mounted() {},
};
</script>
